import { retrieveFromLocalStorage, getPreference } from './util';

export const API_HOST = process.env.REACT_APP_API_ENDPOINT;

const getLoggedInUserHeaders = () => {
  return {
    Authorization: retrieveFromLocalStorage('token'),
    personExternalReference: retrieveFromLocalStorage('personExternalReference'),
    currency_code: getPreference('currency') || 'USD',
  };
};

export const getHttpPostOptions = (data, headers = null, params = null, responseType) => ({
  method: 'POST',
  data,
  headers: { ...getLoggedInUserHeaders(), ...headers },
  params,
  responseType,
});

export const getHttpGetOptions = (headers = null, params = null, responseType) => ({
  method: 'GET',
  headers: { ...getLoggedInUserHeaders(), ...headers },
  params,
  responseType,
});

export const getHttpPutOptions = (data, headers = null, params = null) => ({
  method: 'PUT',
  data,
  headers: { ...getLoggedInUserHeaders(), ...headers },
  params,
});

export const getHttpDeleteOptions = (headers = null, params = null) => ({
  method: 'DELETE',
  headers: { ...getLoggedInUserHeaders(), ...headers },
  params,
});

export const getErrorMessage = (error) => {
  if (error.response?.data) {
    if (error.response.data.message) {
      return error.response.data.message;
    }

    if (error.response.data.responseMessage) {
      return error.response.data.responseMessage;
    }
  }

  if (error.message) {
    return error.message;
  }

  return 'Something went wrong';
};
